import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {SystemLangEditModalComponent} from "./system-lang-edit-modal.component";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "@xref/xref-lib";


@NgModule({
  declarations: [SystemLangEditModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [SystemLangEditModalComponent]
})
export class SystemLangEditModalModule {
}
